import * as React from "react";

const TriangleIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" {...props}>
    <defs>
      <clipPath id="a">
        <path
          data-name="Rect\xE1ngulo 265"
          transform="translate(968 1628.786)"
          fill="#202d5b"
          stroke="#707070"
          d="M0 0h24v24H0z"
        />
      </clipPath>
    </defs>
    <g
      data-name="Enmascarar grupo 16"
      transform="rotate(-135 162.182 1028.328)"
      clipPath="url(#a)"
    >
      <path
        data-name="Rect\xE1ngulo 264"
        fill="#202d5b"
        d="M943.986 1652.769 968 1628.755l24.014 24.014L968 1676.783z"
      />
    </g>
  </svg>
);

export default TriangleIcon;
